import {RefObject, useEffect, useRef} from "react";

/** Knowledge base defines a section as seen once half of it is in the viewport. */
const SECTION_VISIBILITY_THRESHOLD = 0.5;

interface IProps {
    isEnabled?: boolean;
    /** Re-arms the observer when it changes, e.g. after "Pokaż więcej" reveals new cards. */
    impressionKey?: string | number;
    onImpression: () => void;
}

interface IActiveObserver<T extends HTMLElement> {
    element: T;
    impressionKey: IProps["impressionKey"];
    observer: IntersectionObserver;
}

/**
 * Fires a single impression once the observed element becomes visible, so
 * below-the-fold sections are not counted on page load.
 */
export const usePersonalizedHomepageImpression = <T extends HTMLElement = HTMLDivElement>(props: IProps): RefObject<T | null> => {
    const {isEnabled = true, impressionKey} = props;
    const elementRef = useRef<T>(null);
    const onImpressionRef = useRef(props.onImpression);
    const trackedKeysRef = useRef(new Set<IProps["impressionKey"]>());
    const activeObserverRef = useRef<IActiveObserver<T> | null>(null);

    onImpressionRef.current = props.onImpression;

    useEffect(() => {
        const element = elementRef.current;
        const activeObserver = activeObserverRef.current;
        const hasTrackedImpression = trackedKeysRef.current.has(impressionKey);

        if (activeObserver && (!isEnabled || hasTrackedImpression || activeObserver.element !== element || activeObserver.impressionKey !== impressionKey)) {
            activeObserver.observer.disconnect();
            activeObserverRef.current = null;
        }

        if (!isEnabled || !element || hasTrackedImpression || activeObserverRef.current) {
            return;
        }

        const trackImpression = () => {
            trackedKeysRef.current.add(impressionKey);
            onImpressionRef.current();
        };

        if (typeof IntersectionObserver === "undefined") {
            trackImpression();

            return;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                if (
                    activeObserverRef.current?.observer !== observer ||
                    !entries.some((entry) => entry.target === element && entry.isIntersecting && entry.intersectionRatio >= SECTION_VISIBILITY_THRESHOLD)
                ) {
                    return;
                }

                observer.disconnect();
                activeObserverRef.current = null;
                trackImpression();
            },
            {threshold: SECTION_VISIBILITY_THRESHOLD}
        );

        activeObserverRef.current = {element, impressionKey, observer};
        observer.observe(element);
        // A section can attach after a loading placeholder with unchanged props.
        // Check the ref after every commit, while keeping an unchanged observer.
    });

    useEffect(
        () => () => {
            activeObserverRef.current?.observer.disconnect();
            activeObserverRef.current = null;
        },
        []
    );

    return elementRef;
};
import {RefObject, useEffect, useRef} from "react";

/** Knowledge base defines a section as seen once half of it is in the viewport. */
const SECTION_VISIBILITY_THRESHOLD = 0.5;

interface IProps {
    isEnabled?: boolean;
    /** Re-arms the observer when it changes, e.g. after "Pokaż więcej" reveals new cards. */
    impressionKey?: string | number;
    onImpression: () => void;
}

interface IActiveObserver<T extends HTMLElement> {
    element: T;
    impressionKey: IProps["impressionKey"];
    observer: IntersectionObserver;
}

/**
 * Fires a single impression once the observed element becomes visible, so
 * below-the-fold sections are not counted on page load.
 */
export const usePersonalizedHomepageImpression = <T extends HTMLElement = HTMLDivElement>(props: IProps): RefObject<T | null> => {
    const {isEnabled = true, impressionKey} = props;
    const elementRef = useRef<T>(null);
    const onImpressionRef = useRef(props.onImpression);
    const trackedKeysRef = useRef(new Set<IProps["impressionKey"]>());
    const activeObserverRef = useRef<IActiveObserver<T> | null>(null);

    onImpressionRef.current = props.onImpression;

    useEffect(() => {
        const element = elementRef.current;
        const activeObserver = activeObserverRef.current;
        const hasTrackedImpression = trackedKeysRef.current.has(impressionKey);

        if (activeObserver && (!isEnabled || hasTrackedImpression || activeObserver.element !== element || activeObserver.impressionKey !== impressionKey)) {
            activeObserver.observer.disconnect();
            activeObserverRef.current = null;
        }

        if (!isEnabled || !element || hasTrackedImpression || activeObserverRef.current) {
            return;
        }

        const trackImpression = () => {
            trackedKeysRef.current.add(impressionKey);
            onImpressionRef.current();
        };

        if (typeof IntersectionObserver === "undefined") {
            trackImpression();

            return;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                if (
                    activeObserverRef.current?.observer !== observer ||
                    !entries.some((entry) => entry.target === element && entry.isIntersecting && entry.intersectionRatio >= SECTION_VISIBILITY_THRESHOLD)
                ) {
                    return;
                }

                observer.disconnect();
                activeObserverRef.current = null;
                trackImpression();
            },
            {threshold: SECTION_VISIBILITY_THRESHOLD}
        );

        activeObserverRef.current = {element, impressionKey, observer};
        observer.observe(element);
        // A section can attach after a loading placeholder with unchanged props.
        // Check the ref after every commit, while keeping an unchanged observer.
    });

    useEffect(
        () => () => {
            activeObserverRef.current?.observer.disconnect();
            activeObserverRef.current = null;
        },
        []
    );

    return elementRef;
};
